import React, { Component } from "react";
import { truncate } from "../../../utils/truncate";
import {
  notificationItemType,
  notificationMessageType,
} from "../../../utils/constants";
import {
  analyticsCategories,
  toolkitCategories,
} from "../../../utils/categories";
import { getNotificationText } from "../../../utils/notifications";
import moment from "moment";
import "./NotificationItem.css";
import reaction from "../../../assets/stories/workplace_cult.svg";
import mention from "../../../assets/stories/notification_mention.svg";
import { isMobile } from "../../../utils/deviceInfo";

export default class NotificationItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleNotificationClick = () => {
    // console.log("props--", this.props)
    let { notification } = this.props;
    this.props.markAsRead(notification);
    console.log("not----", notification);
    if (notification.messageType === notificationMessageType.officeMateJoined) {
      this.props.history.push("/home/users");
    } else if (
      notification.item.itemType === notificationItemType.tool &&
      notification.item.itemId &&
      notification.item.itemId !== null
    ) {
      let link = "";
      for (let category of toolkitCategories) {
        if (category.name === notification.item.itemId.category) {
          link = category.link;
        }
      }

      console.log("link --- ", link);
      let toolkit_url = `/home/toolkit/${link}/tool/${notification.item.itemId._id}`;

      console.log("url----", toolkit_url);

      if (notification.item.itemId.isArchive.value) {
        let itemOwner = notification.item.itemId.createdBy;
        let currentUser = this.props.user._id;

        if (currentUser === itemOwner) {
          this.props.history.push(toolkit_url);
        } else {
          this.props.history.push(`/home/no-data`);
        }
      } else if (link !== "") {
        this.props.history.push(toolkit_url);
      }
    } else if (
      notification.item.itemType === notificationItemType.chart &&
      notification.item.itemId &&
      notification.item.itemId !== null
    ) {
      let link = "";
      let url = "";
      for (let category of analyticsCategories) {
        if (category.name === notification.item.itemId.category) {
          url = category.link;
        }
      }

      link =
        url +
        "?" +
        `chartId=${notification.item.itemId._id}&notification=${notification._id}`;
      if (notification.item.itemId.isArchive.value) {
        this.props.history.push(`/home/no-data`);
      } else if (link !== "") {
        this.props.history.push("/home/analytics/" + link);
      }
    } else if (
      notification.item.itemType === notificationItemType.story &&
      notification.item.itemId &&
      notification.item.itemId !== null
    ) {
      if (
        notification.messageType === notificationMessageType.comment_flagged
      ) {
        if (
          notification.item.itemId &&
          notification.item.itemId.type === "storyResponse"
        ) {
          let link = `stories/${notification.item.itemId.parentStory.item}`;
          this.props.history.push("/home/" + link);
          return;
        }
      }
      let id = notification.item.itemId._id
        ? notification.item.itemId._id
        : notification.item.itemId;
      let link;
      if (id) {
        link = `stories/${id}?notifications`;
      } else {
        link = `stories/`;
      }
      this.props.history.push("/home/" + link);
    } else if (
      notification.item.itemType === notificationItemType.task &&
      notification.item.itemId &&
      notification.item.itemId !== null
    ) {
      let link = "";
      console.log("task?");
      let id = notification.item.itemId._id;
      link = `planning/${id}`;
      // if(notification.)
      // console.log('noti-----',notification)
      // for (let category of analyticsCategories) {
      //     console.log(category)
      //     if (category.name === notification.item.itemType) {
      //         link = category.link;
      //     }
      // }
      // console.log('itemnote---', notification)

      console.log("go to link!");
      this.props.history.push("/home/" + link);
    } else if (
      notification.item.itemType === notificationItemType.group &&
      notification.item.itemId &&
      notification.item.itemId !== null
    ) {
      let link = `groups/${notification.item.itemId.organizationId}/view/${notification.item.itemId._id}`;
      this.props.history.push("/home/" + link);
    }
    else if(notification.item.itemType == notificationItemType.trivia &&  notification.item.itemId &&
      notification.item.itemId !== null ){
        if(notification.messageType == notificationMessageType.trivvyInvited){
         
          this.props.history.push(`/home/trivia/${notification.organizationId}/quiz/${notification.messageItemId}/start`);
        }
      }
  };

  render() {
    let { notification } = this.props;
    // let isAnonymous = notification.
    let notificationIconClass = "";
    let notificationText = "";
    let senderName = "";
    if (notification) {
      switch (notification.messageType) {
        case notificationMessageType.itemCommented:
          notificationIconClass = "chat";
          break;
        case notificationMessageType.storyResponse:
          notificationIconClass = "paper";
          break;
        case notificationMessageType.storyReaction:
          notificationIconClass = "heart";
          break;
        case notificationMessageType.announcementReaction:
          notificationIconClass = "heart";
          break;
        case notificationMessageType.userMentioned:
          notificationIconClass = "heart";
          break;
        case notificationMessageType.officeMateJoined:
          notificationIconClass = (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-person-circle"
              viewBox="0 0 16 16"
            >
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
              <path
                fill-rule="evenodd"
                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
              />
            </svg>
          );
          break;
        case notificationMessageType.recommendedToolAdded:
          notificationIconClass = "star";
          break;
        case notificationMessageType.itemShared:
          notificationIconClass = "share";
          break;
        case notificationMessageType.itemSharedWithYou:
          notificationIconClass = "share";
          break;
        case notificationMessageType.sharedYourItem:
          notificationIconClass = "share";
          break;
        case notificationMessageType.itemSharedPublicly:
          notificationIconClass = "share";
          break;
        case notificationMessageType.itemEdited:
          notificationIconClass = "edit";
          break;
        case notificationMessageType.itemSharedWithOffice:
          notificationIconClass = "paper";
          break;
        case notificationMessageType.taskAssigned:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskLinked:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskUnlinked:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskCreated:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskUpdate:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskCompleted:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskIncomplete:
          notificationIconClass = "update";
          break;
        case notificationMessageType.taskArchived:
          notificationIconClass = "update";
          break;
        case notificationMessageType.tool_invite:
          notificationIconClass = (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-calendar-plus-fill"
              viewBox="0 0 16 16"
            >
              <path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4V.5zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.5 8.5V10H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V11H6a.5.5 0 0 1 0-1h1.5V8.5a.5.5 0 0 1 1 0z" />
            </svg>
          );
          break;
        case notificationMessageType.group_invite:
          notificationIconClass = (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-people-fill"
              viewBox="0 0 16 16"
            >
              <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              <path
                fill-rule="evenodd"
                d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
              />
              <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
            </svg>
          );
          break;
      }
    }

    if (
      notification.messageType === "STORIES_REACTION" ||
      notification.messageType === "ANNOUNCEMENT_REACTION"
    ) {
      notification.image = reaction;
    }

    if (notification.messageType === "USER_MENTIONS") {
      notification.image = mention;
    }

    // if(notification.messageType.indexOf('_TASK')>-1){
    //     // notification.image =
    // //     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="30" fill="currentColor"
    // //     className="bi bi-card-checklist singleTaskProgressIcon editableTaskField" viewBox="0 0 16 16">
    // //     <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"/>
    // //     <path d="M7 5.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0zM7 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm-1.496-.854a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0z"/>
    // //   </svg>
    // }

    if (notification.senderId) {
      senderName = `${notification.senderId.firstName} ${notification.senderId.lastName}`;
      if (
        notification.item &&
        notification.item.itemId &&
        notification.item.itemId.isAnonymous &&
        notification.item.itemId.isAnonymous !== false
      ) {
        senderName = "Anonymous user";
      }
      // messageItemId
      if (
        notification.messageItemId &&
        notification.messageItemId.isAnonymous
      ) {
        senderName = "Anonymous user";
      }

      if (
        notification.messageType === "STORY_FLAGGED" ||
        notification.messageType === "COMMENT_FLAGGED"
      ) {
        if (notification.isAnonymous) {
          senderName = "Anonymous user";
        }
      }
    }

    if (
      notification.item &&
      notification.item.itemId &&
      notification.item.itemType === "STORIES"
    ) {
      if (notification.item.itemId.privacy !== "REMOVED") {
        if (
          notification.item.itemId.parentStory &&
          notification.item.itemId.parentStory.item
        ) {
          notification.link = notification.item.itemId.parentStory.item;
        } else {
          notification.link = notification.item.itemId._id;
        }
      } else {
        notification.link = "";
      }
    }

    if(notification && (notification.messageType === "STORIES_REACTION" || notification.messageType === "ANNOUNCEMENT_REACTION")  && notification.isAnonymous){
      senderName = "Anonymous user"
   }

    notificationText = getNotificationText(
      notification,
      senderName,
      notification.senderId,
      this.props.user
    );

    return (
      <div
        className={`row ${!isMobile &&
          "mlmr0"} notification-item-container cursor-pointer pt10 pb10`}
        onClick={this.handleNotificationClick}
      >
        <div
          className={`${isMobile &&
            "d-inline-flex story-list-icon"} col-sm-2 plpr0 d-flex justify-content-center`}
        >
          {typeof notificationIconClass == "string" ? (
            <i
              className={"flaticon-" + notificationIconClass}
              style={{ color: "#777777" }}
            ></i>
          ) : (
            notificationIconClass
          )}
        </div>
        <div
          className={`${isMobile &&
            "d-inline-flex story-list-text"} col-sm-9 plpr0 d-flex flex-column justify-content-between`}
        >
          <div className="notification-txt">{notificationText}</div>
          <div className="notification-date">
            {notification
              ? moment(notification.sentDate).format("MMMM D, YYYY")
              : ""}
          </div>
        </div>
        <div
          className={`${isMobile &&
            "d-inline-flex notification-point"} col-sm-1 d-flex align-items-center justify-content-center plpr0`}
        >
          {notification.readDate ? null : (
            <div className="unread-notification-point"></div>
          )}
        </div>
      </div>
    );
  }
}
